var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-head",class:_vm.colorType},[_c('div',{staticClass:"ti"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"topNum"},[_vm._v("TOP  "+_vm._s(_vm.topTxt))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4646326c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/categry/components/RankHead.vue
// module id = null
// module chunks = 